<template lang="pug">
div
  el-form-item
    template(#label) 渲染宽度
      el-tooltip(effect="light", content="单位px/%，默认100%")
        i.el-icon-info
    el-input(v-model="tableWidth")
  el-form-item
    template(#label) 渲染高度
      el-tooltip(effect="light", content="单位px/%，默认600px")
        i.el-icon-info
    el-input(v-model="tableHeight")
  el-divider 关联更新
  el-form-item(label="关联子表")
    el-select(v-model="sublist", allow-create, filterable)
      el-option(v-for="(sf, sfIdx) in subformList", :key="sfIdx", :label="sf.label", :value="sf.name")
  el-form-item(label="关联表格", :rules="nameRequiredRule")
    el-cascader(v-model="relateId", :options="tableListOptions", :props="tableListProps", clearable, filterable)
  el-form-item
    template(#label) 模式
      el-tooltip(effect="light", content="")
        <div slot="content">受控模式（适用于子表的数据量较少、单条子表的数据量也较少，强事务）<br/>&nbsp; 1.主表对子表完全控制<br/>&nbsp; 2.子表数据的加载，由主表单提供子表数据<br/>&nbsp; 3.新增、修改、删除等操作，只在前端更新，并不提交到服务端，所有数据随主表一起提交查看明细时，从前端的列表中拿数据<br/>独立模式（适用于子表的业务数据相对独立，子表的数据量较多或单条子表的数据量较多的场景，非强事务）<br/>&nbsp; 1.主表查询明细时，不再返回子表的数据<br/>&nbsp; 2.子表数据的加载，由子表组件自己完成</div>
        i.el-icon-info
    el-select(v-model="renderMode", allow-create, filterable)
      el-option(v-for="(sf, sfIdx) in renderModelist", :key="sfIdx", :label="sf.label", :value="sf.value")
  el-divider 按钮设置
  el-form-item
    template(#label) 新增状态
      el-tooltip(effect="light", content="列表渲染时，只显示勾选的按钮")
        i.el-icon-info
    el-select(v-model="addBtnShowList", allow-create, filterable, multiple)
      el-option(v-for="(sf, sfIdx) in tableBtnList", :key="sfIdx", :label="sf.label", :value="sf.btnId")
  el-form-item
    template(#label) 编辑状态
      el-tooltip(effect="light", content="列表渲染时，只显示勾选的按钮")
        i.el-icon-info
    el-select(v-model="editBtnShowList", allow-create, filterable, multiple)
      el-option(v-for="(sf, sfIdx) in tableBtnList", :key="sfIdx", :label="sf.label", :value="sf.btnId")
  el-form-item
    template(#label) 查看状态
      el-tooltip(effect="light", content="列表渲染时，只显示勾选的按钮")
        i.el-icon-info
    el-select(v-model="checkBtnShowList", allow-create, filterable, multiple)
      el-option(v-for="(sf, sfIdx) in checkTableBtnList", :key="sfIdx", :label="sf.label", :value="sf.btnId")

</template>

<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { requestTableList } from "@/CommonDP/service/listFlow-service";
import metadataService from "@/CommonDP/service/metadata-service.js";
export default {
  mixins: [settingMixin],
  inject: ["getGlobalDsv"],
  data() {
    return {
      tableListOptions: [],
      tableListProps: { emitPath: false, value: "groupId", label: "groupName", children: "children" },
      nameRequiredRule: [{ required: true, message: "关联列表不可为空" }],
      subformRequiredRule: [{ required: true, message: "关联子表不可为空" }],
      subformList: [],
      renderModelist: [
        {
          label: "受控模式",
          value: 0
        }
        // {
        //   label: "独立模式",
        //   value: 1
        // }
      ]
    };
  },
  computed: {
    ...mapVFOptions("relateId", "tableHeight", "tableWidth", "sublist", "renderMode", "addBtnShowList", "editBtnShowList", "checkBtnShowList", "tableBtnList"),
    formId() {
      return this.getGlobalDsv()?.formId;
    },
    checkTableBtnList() {
      if (this.renderMode === 0) {
        return this.tableBtnList.filter((item) => item.btnType === "check");
      }
      return this.tableBtnList;
    }
  },
  watch: {
    relateId() {
      this.addBtnShowList = [];
      this.editBtnShowList = [];
      this.checkBtnShowList = [];
    }
  },
  mounted() {
    this.getInit();
  },
  methods: {
    async getInit() {
      this.getTableList();
      this.getsubformList();
    },
    async getTableList() {
      this.tableListOptions = [];
      const res = await requestTableList(this.formId);
      this.tableListOptions = res.data || [];
    },
    async getsubformList() {
      this.subformList = [];
      const res = await metadataService.querySubformList(this.formId);
      if (!this.sublist && res.data.length > 0) {
        this.sublist = res.data[0].slaveTableName;
      }
      this.subformList =
        res.data.map((e) => {
          return {
            label: e.slaveTableBusinessName || e.slaveTableName,
            name: e.slaveTableName
          };
        }) || [];
    }
  }
};
</script>
